<template>
    <div class="zone-header">
        
        <div class="d-flex align-items-center mt-1">
            <div class="title font-lg">{{ info.title }}</div>

            <div class="flex-fill"></div>

            <template v-if="mode == 'slide'">
                <template v-if="showBack">
                    <div class="cursor-pointer" @click="$emit('back')">
                        <a-icon type="rollback" /> {{backText}}
                    </div>
                    <div class="line mx-3"></div>
                </template>

                <div
                    class="cursor-pointer"
                    @click="$emit('update:mode', 'list')"
                >
                    <a-icon type="appstore" /> 列表查看
                </div>

                <div class="line mx-3"></div>
                <div class="cursor-pointer" @click="$emit('view-large')">
                    <a-icon type="fullscreen" /> 全屏查看
                </div>
            </template>

            <template v-else-if="mode == 'list'">
                <div
                    class="cursor-pointer"
                    @click="$emit('update:mode', 'slide')"
                >
                    <a-icon type="picture" /> 幻灯片查看
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import DetailHeader from "../components/DetailHeader"

export default {
    model: {
        prop: "mode",
        event: "update:mode"
    },
    props: {
        info: {
            type: Object,
            default() {
                return {}
            }
        },
        mode: String,
        showBack: {
            type: Boolean,
            default: false,
        },
        backText: {
            type: String,
            default: "返回",
        }
    },
    components: { DetailHeader }
}
</script>

<style lang="scss" scoped>
.line {
    height: 2ex;
    width: 1px;
    background: #e2e3e5;
}

.cursor-pointer {
    transition: 0.3s;

    &:hover {
        opacity: 0.7;
    }
}

.zone-header {
    &::v-deep .anticon {
        vertical-align: -0.15em;
    }
}
</style>